import {Appointments} from '@drl/shared/models';

export class AppointmentsData {
  date: Date;
  appointments: Appointments[];
}
